import { render, staticRenderFns } from "./certificateDetails.vue?vue&type=template&id=7ee8206e&scoped=true&"
import script from "./certificateDetails.vue?vue&type=script&lang=js&"
export * from "./certificateDetails.vue?vue&type=script&lang=js&"
import style0 from "./certificateDetails.vue?vue&type=style&index=0&id=7ee8206e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee8206e",
  null
  
)

export default component.exports